<template>
  <div>
    <div style="margin-bottom:10px;">
      <el-radio-group v-model="businessType" size="small">
        <el-radio-button label="0">For INV</el-radio-button>
        <el-radio-button label="1">For PO</el-radio-button>
      </el-radio-group>
    </div>
    <template v-if="businessType === '0'">
      <div class="table-title" style="margin-top:10px;">
        INV Records ({{ invListLength }} Records)&nbsp;&nbsp;
        INV Status:&nbsp;
        <select v-model="invParams.is_del" @change="fetchInvList">
          <option :value="null">ALL</option>
          <option value="1">Valid Only</option>
        </select>&nbsp;&nbsp;
        INV Year:&nbsp;
        <select v-model="invParams.year" @change="fetchInvList">
          <option :value="null">ALL</option>
          <option value="2019">2020</option>
          <option value="2019">2019</option>
          <option value="2018">2018</option>
          <option value="2017">2017</option>
        </select>&nbsp;&nbsp;
        INV Summary Total:&nbsp;{{ invTotal|1000 }}&nbsp;USD&nbsp;
        Total Profit:&nbsp;{{ invTotalProfit|1000 }}&nbsp;USD
      </div>
      <table class="fixed-table">
        <tr>
          <th>Issue Date</th>
          <th>INV No.</th>
          <th>Cost (USD)</th>
          <th>Amount (USD)</th>
          <th>Charges (USD)</th>
          <th>Profit (USD)</th>
          <th>Balance (USD)</th>
          <th>Days away</th>
          <th>Status</th>
          <th>Sales</th>
        </tr>
        <tr v-for="item in invList" :key="item.id">
          <td>{{ item.doc_date }}</td>
          <td><a @click="$open(`/invoice-order-view/${item.id}`, 840)">INV&nbsp;CYS{{ item.id }}</a></td>
          <td>{{ item.cost|1000 }}</td>
          <td>{{ item.total_charge_usd|1000 }}</td>
          <td>0</td>
          <td v-if="item.is_del === '0'">{{ item.profit|1000 }}</td>
          <td v-else>&nbsp;</td>
          <td>{{ item.total_charge_usd - item.pay_amount | 1000 }}</td>
          <td>{{ item.days_away }}</td>
          <td v-if="item.is_del === '0'">&nbsp;</td>
          <td v-else style="color:red;">Void</td>
          <td>{{ item.sales_name }}</td>
        </tr>
      </table>
    </template>

    <template v-else>
      <div class="table-title" style="margin-top:10px;">
        PO Records ({{ poListLength }} Records)&nbsp;&nbsp;
        PO Status:&nbsp;
        <select v-model="poParams.is_del" @change="fetchPOList">
          <option :value="null">ALL</option>
          <option value="1">Valid Only</option>
        </select>&nbsp;&nbsp;
        PO Year:&nbsp;
        <select v-model="poParams.year" @change="fetchPOList">
          <option :value="null">ALL</option>
          <option value="2019">2020</option>
          <option value="2019">2019</option>
          <option value="2018">2018</option>
          <option value="2017">2017</option>
        </select>&nbsp;&nbsp;
        PO Summary Total:&nbsp;{{ poTotal|1000 }}&nbsp;USD&nbsp;
        Total Profit:&nbsp;{{ poTotalProfit|1000 }}&nbsp;USD
      </div>
      <table class="fixed-table">
        <tr>
          <th>Issue Date</th>
          <th>PO No.</th>
          <th>Cost (USD)</th>
          <th>Amount (USD)</th>
          <th>Charges (USD)</th>
          <th>Profit (USD)</th>
          <th>Balance (USD)</th>
          <th>Days away</th>
          <th>Status</th>
          <th>Sales</th>
        </tr>
        <tr v-for="item in poList" :key="item.id">
          <td>{{ item.doc_date }}</td>
          <td><a @click="$open(`/po-order-view/${item.id}`, 840)">PO&nbsp;CYS{{ item.id }}</a></td>
          <td>&nbsp;</td>
          <td>{{ item.total_charge_usd|1000 }}</td>
          <td>0</td>
          <td v-if="item.is_del === '0'">{{ item.profit|1000 }}</td>
          <td v-else>&nbsp;</td>
          <td>{{ item.total_charge - item.pay_amount | 1000 }}</td>
          <td>{{ item.days_away }}</td>
          <td v-if="item.is_del === '0'">&nbsp;</td>
          <td v-else style="color:red;">Void</td>
          <td>{{ item.sales_name }}</td>
        </tr>
      </table>
    </template>
  </div>
</template>

<script>
import NP from 'number-precision'
export default {
  data () {
    return {
      company: {
        id: this.$route.params.id,
        name: ''
      },
      businessType: '0',
      poParams: {
        is_del: null,
        year: null
      },
      poList: [],
      invParams: {
        is_del: null,
        year: null
      },
      invList: []
    }
  },
  computed: {
    user () {
      return this.$store.state.user
    },
    poListLength () {
      return this.poList.filter(r => r.is_del === '0').length
    },
    invListLength () {
      return this.invList.filter(r => r.is_del === '0').length
    },
    poTotal () {
      let t = 0
      for (let i = 0; i < this.poList.length; i++) {
        if (this.poList[i].is_del !== '1') {
          t = NP.plus(t, parseFloat(this.poList[i].total_charge_usd || this.poList[i].total_charge))
        }
      }
      return t
    },
    poTotalProfit () {
      let t = 0
      for (let i = 0; i < this.poList.length; i++) {
        if (this.poList[i].is_del !== '1') {
          t = NP.plus(t, parseFloat(this.poList[i].profit))
        }
      }
      return t
    },
    invTotal () {
      let t = 0
      for (let i = 0; i < this.invList.length; i++) {
        if (this.invList[i].is_del !== '1') {
          t = NP.plus(t, parseFloat(this.invList[i].total_charge_usd || this.invList[i].total_charge))
        }
      }
      return t
    },
    invTotalProfit () {
      let t = 0
      for (let i = 0; i < this.invList.length; i++) {
        if (this.invList[i].is_del !== '1') {
          t = NP.plus(t, parseFloat(this.invList[i].profit))
        }
      }
      return t
    }
  },
  mounted () {
    this.fetchCompany()
    this.fetchPOList()
    this.fetchInvList()
  },
  methods: {
    fetchCompany () {
      this.$http.get('/dbapi/company_list', {
        params: {
          id: this.$route.params.id
        }
      }).then(data => {
        if (data.list.length > 0) {
          this.company = data.list[0]
        }
      })
    },
    fetchPOList () {
      this.$http.get('/dbapi/po_doc_list', {
        params: {
          company_id: this.$route.params.id,
          ...this.poParams
        }
      }).then(data => {
        this.poList = data.list
      })
    },
    fetchInvList () {
      this.$http.get('/dbapi/pi_doc_list', {
        params: {
          company_id: this.$route.params.id,
          ...this.invParams
        }
      }).then(data => {
        let list = data.list
        for (let i = 0; i < list.length; i++) {
          list[i].cost = NP.minus(list[i].total_charge_usd, list[i].profit)
        }
        this.invList = list
      })
    }
  }
}
</script>